import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
    apiKey: "AIzaSyBd0DZvtp90bpxwdyhlXw2jXQEx2S6dvwg",
    authDomain: "portfolio-3ec68.firebaseapp.com",
    projectId: "portfolio-3ec68",
    storageBucket: "portfolio-3ec68.appspot.com",
    messagingSenderId: "511804460091",
    appId: "1:511804460091:web:9a843b6ff4dbb8dffde01e",
    measurementId: "G-D7P3WXN1WJ"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const functions = getFunctions(app)